import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';

export const router = new VueRouter({
	base: '',
	routes,
});

Vue.use(VueRouter);
